import { useSelector } from "react-redux";
import * as Sentry from "@sentry/nextjs";

export const useCreateMediaStream = () => {
  const { video, audio, videoStream, screenStream } = useSelector(
    (state) => state.device,
  );

  const getAudio = (audio, callback) => {
    const constraints = {
      audio: {
        deviceId: audio ? { exact: audio } : true,
      },
      video: false,
    };
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(callback)
      .catch((err) => {
        console.log(err.name);
        if (err.name === "OverconstrainedError") {
          console.log("선택한 기기를 찾을 수 없습니다.");
        } else {
          console.log(err.name);
        }
      });
  };

  //웹캠로드 함수
  const getWebcam = (callback) => {
    if (videoStream?.id) {
      videoStream.getTracks().forEach((track) => {
        track.stop();
      });
    }

    const initialConstraints = {
      audio: false,
      video: true,
      facingMode: { exact: "user" },
    };

    const constraints = {
      audio: {
        deviceId: audio,
      },
      video: {
        deviceId: video,
        width: 320,
        height: 240,
        frameRate: { max: 4 },
      },
      facingMode: { exact: "user" },
    };
    try {
      navigator.mediaDevices
        .getUserMedia(video ? constraints : initialConstraints)
        .then(callback)
        .catch((err) => {
          Sentry.captureException(err, {
            tags: { type: "webcam_failure", errorName: err.name },
          });
          alert(
            "웹캠을 불러오지 못 하였습니다. 다른 장치에서 사용중이 아닌지 확인해 주세요.",
          );
          console.log(err);
        });
    } catch (err) {
      Sentry.captureException(err, {
        tags: { type: "webcam_failure", errorName: err.name },
      });
      alert(
        "웹캠을 불러오지 못 하였습니다. 다른 장치에서 사용중이 아닌지 확인해 주세요.",
      );
      console.log(err);
      return undefined;
    }
  };

  const getScreen = (callback) => {
    if (screenStream?.id) {
      screenStream?.getTracks().forEach((track) => {
        track.stop();
        console.log(track);
      });
    }
    const constraints = {
      video: {
        width: { max: 1280 },
        height: { max: 720 },
        frameRate: { max: 4 },
        cursor: "motion",
        displaySurface: "monitor",
      },
      audio: false,
    };
    try {
      navigator.mediaDevices
        .getDisplayMedia(constraints)
        .then(callback)
        .catch((error) => {
          console.log(error);
          console.warn(
            "get stream failed: " + JSON.stringify(constraints, null, "  "),
          );
          console.warn("onGetStreamFailed error message: " + error.message);
          console.warn("error name: " + error.name);
          console.warn("error constraint: " + error.constraints);
          if (
            error.name === "OverconstrainedError" ||
            error.name === "ConstraintNotSatisfiedError"
          ) {
            // constraints can not be satisfied by avb.device
            console.info("constraints can not be satisfied by avb.device");
          } else {
            if (
              error.name === "NotFoundError" ||
              error.name === "DeviceNotFoundError"
            ) {
              // require track is missing
              console.info("require track is missing");
            } else if (
              error.name === "NotReadableError" ||
              error.name === "TrackStartError"
            ) {
              // webcam or mic are already in use
              console.info("webcam or mic are already in use");
            } else if (
              error.name === "NotAllowedError" ||
              error.name === "PermissionDeniedError" ||
              error.name === "PermissionDismissedError"
            ) {
              // permission denied in browser
              console.info("permission denied in browser");
            } else if (error.name === "TypeError") {
              // empty constraints object
              console.info("empty constraints object");
            } else {
              // other errors
              console.info("other errors " + error.name);
            }
          }
          Sentry.captureException(error, {
            tags: { type: "screen_share_failure", errorName: error.name },
          });

          if (
            error.name === "NotAllowedError" ||
            error.name === "PermissionDeniedError" ||
            error.name === "PermissionDismissedError"
          ) {
            alert(
              "화면 공유가 취소되었습니다.\n공유 화면을 선택하여 주세요.",
            );
          } else if (
            error.name === "NotFoundError" ||
            error.name === "DeviceNotFoundError"
          ) {
            alert(
              "공유 가능한 화면을 찾을 수 없습니다.\n모니터 연결 상태를 확인해 주세요.",
            );
          } else if (
            error.name === "NotReadableError" ||
            error.name === "TrackStartError"
          ) {
            alert(
              "화면이 다른 프로그램에서 사용 중입니다.\n다른 화면 공유 프로그램을 종료 후 다시 시도해 주세요.",
            );
          } else if (
            error.name === "OverconstrainedError" ||
            error.name === "ConstraintNotSatisfiedError"
          ) {
            alert(
              "화면 공유 설정을 만족하는 화면이 없습니다.\n다른 화면을 선택하여 주세요.",
            );
          } else {
            alert(
              "화면 공유에 실패하였습니다.\n공유 화면을 선택하여 주세요.",
            );
          }
          getScreen(callback);
        });
    } catch (err) {
      Sentry.captureException(err, {
        tags: { type: "screen_share_failure", errorName: err.name },
      });
      alert("화면 공유에 실패하였습니다.");
      console.log("화면 공유에 실패하였습니다." + err);
    }
  };

  return {
    getWebcam,
    getScreen,
    getAudio,
  };
};
